import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
/** Services Import */
import Global from '../../Services/Common/Global';
import Commons from '../../Services/Common/Common';
/** Components */
import { Login, FindId, SignUp } from './index';
import FindPw from './FindPw';
import { Loading, Dialog, Button } from '../../Components/MUIs';
import { Box, IconButton, Typography } from '@mui/material';
/** Icons Import */
import { Close as CloseIcon } from '@mui/icons-material';
import PersonSearch from '@mui/icons-material/PersonSearch';
import { useDispatch } from 'react-redux';
import { BaseInfoActions } from '../../Reducer/BaseInfoReducer';
import { showSnackbar } from '../../Reducer/SnackbarReducer';
import { initFcm } from '../../firebase';
import useErrorHandler from '../../hooks/useErrorHandler';
import { MOK_FINDPW_RESULT_KEY } from './IdentityMokCallback';
import { Login_Schema } from './Login_Schema';
import { createInitial } from '../../util';

function LoginFunction() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // 에러 처리
  const { handleError } = useErrorHandler();
  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    content: null,
    type: '',
  }); // 팝업 객체
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    userId: Commons.Storages('get', 'settings').userIdKeep
      ? Commons.Storages('get', 'settings').userId
      : '', // user id
    userPw: '', // user password
    passwordVisible: false, // 패스워드 보기 버튼 토글
    lanCd: Commons.Storages('get', 'settings').lanCd
      ? Commons.Storages('get', 'settings').lanCd
      : '', // 언어 선택 콤보 선택 값 저장하는 변수
    userIdKeep: Commons.Storages('get', 'settings').userIdKeep, // 아이디 저장 값 저장 변수
    loginKeep: Commons.Storages('get', 'settings').loginKeep, // 자동 로그인 값 저장 변수
  });
  const [lanCdList, setLanCdList] = useState([]); // Language Combobox list
  const [lanList, setLanList] = useState([]); // Language list
  const [codeList, setCodeList] = useState([]); // code list
  const [findIdInputs, setFindIdInputs] = useState({
    userId: '',
    foundIds: [],
    userNm: '',
    userTel: '',
    successful: false,
  }); // FindId Component inputs
  const [findPwInputs, setFindPwInputs] = useState(() =>
    createInitial(Login_Schema.fields.findPwForm)
  );
  const [signUpInputs, setSignUpInputs] = useState({
    serviceUsingCheck: false, // 서비스 이용동의
    personalInformationCheck: false, // 개인정보 수집 및 이용동의
    locationSerciveCheck: false, // 위치기반 서비스 이용동의
    aged14Check: false, // 만 14세 이상동의
    marketingCheck: false, // 마케팅 목적 개인정보 수집 및 이용동의
    allAgreeCheck: false, // 전체 동의
    userId: '',
    idDuplicationCheck: '', // ID 중복 확인
    userNm: '',
    userPw: '',
    userPwConfirm: '', // Password 확인
    userTel: '',
    userEmTel: '',
    userEmail1: '',
    userEmail2: '',
    emailCombo: 'jigjub',
    userBlood: '',
    userAddress1: '',
    userAddress2: '',
    userPost: '',
    userNation: '',
    userVisa: '',
    userAuth: 'EMPLOYEE',
    authRegion: '',
    userAuthDtl: '',
    successful: false,
    userType: 0, // 0: 근로자, 1: 관리자
    userTypeList: [],
    bloodList: [],
    nationList: [],
    authList: [],
    authDtlList: [],
    nationList: [],
  }); // Sign up Component inputs
  const [authGroups, setAuthGroups] = useState([]); // 관리자 권한 목록 저장 변수
  const [regions, setRegions] = useState([]); // 지역 목록 저장 변수
  const [siteList, setSiteList] = useState([]); // 현장별 지역 목록
  const [siteManagerSite, setSiteManagerSite] = useState(''); // 현장 관리자가 선택한 현장 AutoComplete 저장 변수
  const [siteManagerSiteInput, setSiteManagerSiteInput] = useState(''); // 현장 관리자가 선택한 현장 AutoComplete 저장 변수
  const [custList, setCustList] = useState([]); // 사업체 목록
  const [headManagerSite, setHeadManagerSite] = useState(''); // 본사 관리자가 선택한 사업체 AutoComplete 저장 변수
  const [headManagerSiteInput, setHeadManagerSiteInput] = useState(''); // 본사 관리자가 선택한 사업체 AutoComplete 저장 변수
  const [confirmPw, setConfirmPw] = useState(true);
  const [confirmId, setConfirmId] = useState(true);
  const [successLogin, setSuccessLogin] = useState(false);

  useEffect(() => {
    const findPwStored = sessionStorage.getItem(MOK_FINDPW_RESULT_KEY);
    if (findPwStored) {
      try {
        JSON.parse(findPwStored);
        setDialog({
          open: true,
          title: '',
          content: null,
          type: 'FindPw',
        });
      } catch (_) {
        sessionStorage.removeItem(MOK_FINDPW_RESULT_KEY);
      }
    }

    Init();
  }, []);

  useEffect(() => {
    if (
      signUpInputs.serviceUsingCheck &&
      signUpInputs.personalInformationCheck &&
      signUpInputs.locationSerciveCheck &&
      signUpInputs.aged14Check &&
      signUpInputs.marketingCheck
    ) {
      setSignUpInputs({
        ...signUpInputs,
        allAgreeCheck: true,
      });
    } else {
      setSignUpInputs({
        ...signUpInputs,
        allAgreeCheck: false,
      });
    }
  }, [
    signUpInputs.serviceUsingCheck,
    signUpInputs.personalInformationCheck,
    signUpInputs.locationSerciveCheck,
    signUpInputs.aged14Check,
    signUpInputs.marketingCheck,
  ]);

  const Init = async () => {
    setLoading(true);
    let lanCodeData = [];
    let lanData = [];
    let codeData = [];
    let userTypeData = [];
    let bloodData = [];
    let authData = [];
    let regionData = [];
    let nationData = [];

    try {
      const response = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.getLanguage,
        {
          LanguageCode: Commons.EncryptAES(inputs.lanCd ? inputs.lanCd : 'kr'),
        }
      );
      let data = response.data;
      if (data.type === 'Error') {
        throw new Error(data.message);
      } else {
        if (data.lanList.length > 0) {
          data.lanList.forEach((item, index) => {
            lanData.push(item);
          });
        }
        if (data.lanCode.length > 0 && data.lanList.length > 0) {
          data.lanCode.forEach((item, index) => {
            codeData.push(item);
            if (item.groupCd === 'LAN_CD') {
              lanCodeData.push({
                name: data.lanList.filter(
                  (f) => f.lanId === 'CD_' + item.code
                )[0].lanNm,
                value: item.code,
              });
            } else if (item.groupCd === 'USER_TYPE') {
              userTypeData.push({
                name: data.lanList.filter(
                  (f) => f.lanId === 'CD_' + item.code
                )[0].lanNm,
                value: item.code,
              });
            } else if (item.groupCd === 'BloodType') {
              bloodData.push({
                name: item.codeNm,
                value: item.code,
              });
            } else if (item.groupCd === 'AUTH' && item.val1 !== '0') {
              authData.push({
                name: item.name,
                value: item.code,
                seq: item.val1,
              });
            } else if (item.groupCd === 'REGION' && item.code !== 'REGION') {
              regionData.push({
                name: data.lanList.filter(
                  (f) => f.lanId === 'CD_' + item.code
                )[0].lanNm,
                value: item.code,
              });
            } else if (item.groupCd === 'NATION') {
              nationData.push({
                name: item.codeNm,
                value: item.code,
              });
            }
          });
        } else {
          throw new Error('Data abnormality!');
        }

        setLanCdList(lanCodeData);
        setLanList(lanData);
        setCodeList(codeData);
        setAuthGroups(authData.sort((a, b) => a.seq - b.seq));
        setRegions(regionData);
        setSignUpInputs({
          ...signUpInputs,
          userType: 'EMPLOYEE',
          userTypeList: userTypeData.reverse(),
          bloodList: bloodData,
          userNation: 'KR',
          nationList: nationData,
        });
      }
    } catch (e) {
      // 에러 처리 (401 등은 자동으로 다이얼로그 표시)
      if (e.shouldShowDialog) {
        return;
      }
      await handleError(e, {
        url: Global.base.useUrl + Global.urls.Account.getLanguage,
        method: 'post',
      });
    } finally {
      setLoading(false);
    }
  };

  // 언어 선택 콤보박스 선택 시 마다 언어 리스트 가져오는 함수
  const SearchLogic1 = async (_value1) => {
    setLoading(true);
    let lanData = [];

    try {
      Commons.Storages('set', 'settings', {
        ...Commons.Storages('get', 'settings'),
        lanCd: _value1,
      });

      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.getLanguage,
        {
          value1: Commons.EncryptAES(_value1),
        }
      ).then((result) => {
        let data = result.data;

        if (data.type === 'Error') {
          throw new Error(data.message);
        } else {
          if (data.lanList.length > 0) {
            data.lanList.forEach((item, index) => {
              lanData.push(item);
            });
          }

          setLanList(lanData);
          // lanCdList.map((item, index) => {
          // 	item.name = lanData.filter(
          // 		(f) => f.lanId === "CD_" + item.value
          // 	)[0].lanNm;
          // }); // Language 콤보박스 바꿀때 마다 콤보박스안에 코드 데이터까지 매칭하던 코드
        }
      });
    } catch (e) {
      // 에러 처리 (401 등은 자동으로 다이얼로그 표시)
      if (e.shouldShowDialog) {
        return;
      }
      await handleError(e, {
        url: Global.base.useUrl + Global.urls.Account.getLanguage,
        method: 'post',
      });
    } finally {
      setLoading(false);
    }
  };

  // Checkbox 선택 로직 함수
  const ChangeCheckbox = (_type, _data) => {
    if (_type === 'id') {
      setInputs({
        ...inputs,
        userIdKeep: _data,
      });
      Commons.Storages('set', 'settings', {
        ...Commons.Storages('get', 'settings'),
        userIdKeep: _data,
      });
    } else if (_type === 'account') {
      setInputs({
        ...inputs,
        loginKeep: _data,
      });
      Commons.Storages('set', 'settings', {
        ...Commons.Storages('get', 'settings'),
        loginKeep: _data,
      });
    }
  };

  // Group button을 누를 때 어떤 Dialog를 뿌릴지 결정하는 함수
  const DialogLogic = (_type) => {
    switch (_type) {
      case 'FindId':
        return setDialog({
          ...dialog,
          open: true,
          title:
            lanList.length > 0
              ? lanList.filter((f) => f.lanId === 'FindId')[0].lanNm
              : '', // ID 찾기
          type: _type,
        });
      case 'FindPw':
        return setDialog({
          ...dialog,
          open: true,
          title: '',
          content: null,
          type: _type,
        });
      case 'SignUp':
        return setDialog({
          ...dialog,
          open: true,
          title:
            lanList.length > 0
              ? lanList.filter((f) => f.lanId === 'SignUp')[0].lanNm
              : '', // 회원가입
          content: null,
          type: _type,
        });
    }
  };

  // 로그인 예외처리 함수
  const LoginValidation = () => {
    if (!inputs.userId) {
      setConfirmId(false);
      dispatch(
        showSnackbar({
          message:
            lanList.find((f) => f.lanId === 'PleaseCheckYourId')?.lanNm ||
            '아이디를 확인해주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    if (!inputs.userPw) {
      setConfirmPw(false);
      dispatch(
        showSnackbar({
          message:
            lanList.find((f) => f.lanId === 'PleaseCheckYourPassword')?.lanNm ||
            '비밀번호를 확인해주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    return true;
  };

  // 로그인 함수
  const LoginLogic = async () => {
    setLoading(true);

    if (!LoginValidation()) {
      setLoading(false);
      return false;
    }

    let userInfo = [];
    let menuInfo = [
      {
        NO: 0,
        AUTH_CD: '',
        AUTH_NM: '',
        MENU_UP: '',
        DELETE_YN: 'N',
        PRO_ID: 'Home',
        MENU_NM: 'Home',
        MENU_TYPE: '0',
        MENU_UP: 'Home',
        PRINT_YN: 'N',
        SAVE_YN: 'N',
        SCREEN_TYPE: '0',
        SEQ: 0,
        open: false,
      },
    ];
    let lanInfo = [];
    let custInfo = [];
    let companyInfo = [];

    try {
      if (Commons.Storages('get', 'companyInfo')) {
        Commons.Storages('remove', 'companyInfo');
      }

      const fcmResult = await initFcm();
      const firebaseToken = fcmResult?.token || '';
      const response = await Commons.Axios(
        'login',
        Global.base.useUrl + Global.urls.Account.login,
        {
          value2: Commons.EncryptAES(inputs.userId),
          value3: Commons.EncryptAES(inputs.userPw),
          keep: inputs.loginKeep,
          value1: Commons.EncryptAES('Kr'),
          value4: Commons.EncryptAES(firebaseToken),
          value5: Commons.EncryptAES(Commons.IsMobile() ? 'Y' : 'N'),
          value6: Commons.EncryptAES(Commons.DeviceCheck()),
        }
      );
      const data = response.data;
      console.log('LOGIN_data', data);
      if (!data || data === false) {
        setConfirmId(false);
        setConfirmPw(false);
        dispatch(
          showSnackbar({
            message:
              lanList.find((f) => f.lanId === 'PleaseCheckYourId')?.lanNm ||
              '아이디 혹은 비밀번호가 일치하지 않습니다.',
            type: 'warning',
          })
        );
        return false;
      }

      const responseUserInfo = data.userInfo || data.UserInfo;
      const responseMenuInfo = data.menuInfo || data.MenuInfo || [];
      const responseLanInfo = data.lanInfo || data.LanInfo || [];
      const responseCustInfo = data.custInfo || data.CustInfo || [];
      const responseCompanyInfo = data.companyInfo || data.CompanyInfo || [];

      // 계약 기간: 일(날짜) 단위만 비교
      const today = dayjs().startOf('day');
      const contractStart = dayjs(
        responseCompanyInfo[0].contractStartDate
      ).startOf('day');
      const contractEnd = dayjs(responseCompanyInfo[0].contractEndDate).startOf(
        'day'
      );
      if (
        today.isBefore(contractStart, 'day') ||
        today.isAfter(contractEnd, 'day')
      ) {
        dispatch(
          showSnackbar({
            message: '계약 기간이 아닙니다. 계약 기간을 확인해주세요.',
            type: 'warning',
          })
        );
        return false;
      }

      if (!responseUserInfo) {
        throw new Error('사용자 정보를 찾을 수 없습니다.');
      }

      if (
        ['EMPLOYEE', 'SITE_MANAGER', 'DEP_MANAGER'].includes(
          responseUserInfo.authCd
        )
      ) {
        setConfirmId(false);
        const denyMessageMap = {
          EMPLOYEE: '근로자 계정으로 로그인할 수 없습니다.',
          SITE_MANAGER: '현장관리자 계정으로 로그인할 수 없습니다.',
          DEP_MANAGER: '부서장 계정으로 로그인할 수 없습니다.',
        };

        dispatch(
          showSnackbar({
            message: denyMessageMap[responseUserInfo.authCd],
            type: 'warning',
          })
        );
        return false;
      }

      userInfo.push(data.userInfo);

      Commons.Storages('set', 'auth', { auth: true });

      userInfo.push({
        ...responseUserInfo,
        connTime: new Date().toISOString(),
      });
      responseLanInfo.forEach((item) => lanInfo.push(item));
      dispatch(BaseInfoActions.setUserInfo(userInfo[0]));
      dispatch(
        BaseInfoActions.setMenuInfo(
          responseMenuInfo.filter((m) => {
            const id = m.menuId ?? m.MENU_ID ?? '';
            if (id === 'RiskNearMiss') return false;
            if (id === 'SuggestionList') return true;
            return true;
          })
        )
      );
      dispatch(BaseInfoActions.setLanInfo(responseLanInfo));
      dispatch(BaseInfoActions.setCustInfo(responseCustInfo));
      dispatch(BaseInfoActions.setCompanyInfo(responseCompanyInfo));

      Commons.Storages('set', 'auth', { auth: true });

      setConfirmId(true);
      setConfirmPw(true);
      setSuccessLogin(true);

      setTimeout(() => {
        setSuccessLogin(false);
        navigate('/Home');
      }, 3000);
    } catch (e) {
      // 로그인은 login 타입이므로 에러 처리를 bypass하므로 여기서만 처리
      console.error(e.message);

      setConfirmId(false);
      setConfirmPw(false);
      const message =
        e?.response?.data ||
        e?.message ||
        '로그인 처리 중 오류가 발생했습니다.';
      dispatch(showSnackbar({ message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  // 각 팝업창의 save button 리턴 함수
  const CreateDialogButton = (_type) => {
    switch (_type) {
      case 'FindId':
        if (!findIdInputs.successful) {
          return (
            <Button
              name={
                lanList.length > 0
                  ? lanList.filter((f) => f.lanId === 'Find')[0].lanNm
                  : ''
              }
              onClick={() => SearchLogic2()}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                px: 2.5,
                boxShadow: 'none',
                bgcolor: '#78CB70',
                color: '#fff',
                '&:hover': {
                  bgcolor: '#66b85f',
                  boxShadow: 'none',
                },
              }}
            />
          );
        } else {
          return null;
        }
      case 'SignUp':
    }
  };

  // 아이디 찾기 예외 처리
  const FindIdValidation = () => {
    if (!findIdInputs.userNm) {
      dispatch(
        showSnackbar({
          message:
            lanList.length > 0
              ? lanList.filter((f) => f.lanId === 'PleaseEnterYourName')[0]
                  .lanNm
              : '',
          type: 'warning',
        })
      );

      return false;
    } else if (!findIdInputs.userTel) {
      dispatch(
        showSnackbar({
          message:
            lanList.length > 0
              ? lanList.filter(
                  (f) => f.lanId === 'PleaseEnterYourPhoneNumber'
                )[0].lanNm
              : '',
          type: 'warning',
        })
      );

      return false;
    } else return true;
  };

  /** 회원 TEL — 공백만 제거(하이픈 유지) */
  const StripTelSpacesLogicN = (tel) => String(tel || '').replace(/\s/g, '');

  /** 숫자만 */
  const DigitsOnlyTelLogicN = (tel) => String(tel || '').replace(/[^0-9]/g, '');

  /**
   * DB에 전화번호가 하이픈 포함/미포함 혼재 — 조회·검증 시 두 형태 순차 시도
   * 숫자만 형태를 먼저 시도(DB에 무하이픈 저장이 흔함)
   */
  const BuildTelVariantsLogicN = (tel) => {
    const spaced = StripTelSpacesLogicN(tel);
    const digits = DigitsOnlyTelLogicN(spaced);
    const list = [];
    const seen = new Set();
    for (const v of [digits, spaced]) {
      if (v && !seen.has(v)) {
        seen.add(v);
        list.push(v);
      }
    }
    return list;
  };

  /** Commons.Axios가 404를 customError로 감싸면 response가 없음 — 재시도 판별용 */
  const ShouldContinueTelVariantAfterErrorLogicN = (err) => {
    const status = err?.response?.status ?? err?.errorInfo?.statusCode;
    if (status === 404) return true;
    if (err?.errorInfo?.type === 'NOT_FOUND') return true;
    return false;
  };

  /** API 응답 type 대소문자 무시 */
  const IsOkTypeLogicN = (data) =>
    String(data?.type ?? data?.Type ?? '')
      .toLowerCase()
      .trim() === 'ok';

  // 아이디 찾기 함수 — 서버: GetFindId body { userName, tel } AES, 응답 FindIdResult[] 또는 404
  const SearchLogic2 = async () => {
    setLoading(true);

    if (!FindIdValidation()) {
      setLoading(false);
      return false;
    }

    try {
      const nameEnc = Commons.EncryptAES(findIdInputs.userNm.trim());
      const telVariants = BuildTelVariantsLogicN(findIdInputs.userTel);
      let foundIds = null;
      let lastError = null;

      for (const telVariant of telVariants) {
        try {
          const result = await Commons.Axios(
            'post',
            Global.base.useUrl + Global.urls.Account.getFindId,
            {
              UserName: nameEnc,
              Tel: Commons.EncryptAES(telVariant),
            },
            null,
            { suppressGlobalError: true }
          );
          const rows = Array.isArray(result.data) ? result.data : [];
          const ids = rows
            .map((row) => row?.id ?? row?.Id ?? '')
            .filter(Boolean);
          if (ids.length > 0) {
            foundIds = ids;
            break;
          }
        } catch (err) {
          lastError = err;
          if (ShouldContinueTelVariantAfterErrorLogicN(err)) continue;
          throw err;
        }
      }

      if (!foundIds || foundIds.length === 0) {
        throw (
          lastError ||
          new Error(
            lanList.find((f) => f.lanId === 'IdNotFound')?.lanNm ||
              '일치하는 회원이 없습니다.'
          )
        );
      }

      setFindIdInputs({
        ...findIdInputs,
        foundIds,
        userId: foundIds[0],
        successful: true,
      });
    } catch (e) {
      if (e.shouldShowDialog) {
        return;
      }
      const msg =
        e?.response?.status === 404
          ? lanList.find((f) => f.lanId === 'IdNotFound')?.lanNm ||
            '일치하는 회원이 없습니다.'
          : e?.response?.data?.message ||
            e?.message ||
            '아이디 찾기 처리 중 오류가 발생했습니다.';
      dispatch(showSnackbar({ message: String(msg), type: 'warning' }));
      if (e?.response?.status !== 404) {
        await handleError(e, {
          url: Global.base.useUrl + Global.urls.Account.getFindId,
          method: 'post',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  // 비밀번호 찾기 / 비밀번호 바꾸기 예외 처리
  const FindPwValidation = (_type = 0) => {
    if (_type === 0 && !findPwInputs.userId) {
      dispatch(
        showSnackbar({
          message:
            lanList.length > 0
              ? lanList.filter((f) => f.lanId === 'PleaseEnterYourId')[0].lanNm
              : '',
          type: 'warning',
        })
      );

      return false;
    } else if (_type === 0 && !findPwInputs.userNm) {
      dispatch(
        showSnackbar({
          message:
            lanList.length > 0
              ? lanList.filter((f) => f.lanId === 'PleaseEnterYourName')[0]
                  .lanNm
              : '',
          type: 'warning',
        })
      );
      return false;
    } else if (_type === 0 && !findPwInputs.userTel) {
      dispatch(
        showSnackbar({
          message:
            lanList.find((f) => f.lanId === 'PleaseEnterYourPhoneNumber')
              ?.lanNm || '전화번호를 입력해주세요.',
          type: 'warning',
        })
      );
      return false;
    } else if (_type === 1 && !findPwInputs.userPw) {
      dispatch(
        showSnackbar({
          message:
            lanList.find((f) => f.lanId === 'PleaseEnterYourPassword')?.lanNm ||
            '비밀번호를 입력해주세요.',
          type: 'warning',
        })
      );
      return false;
    } else if (_type === 1 && !findPwInputs.userPwConfirm) {
      dispatch(
        showSnackbar({
          message:
            lanList.length > 0
              ? lanList.filter(
                  (f) => f.lanId === 'PleaseEnterYourPasswordConfirm'
                )[0].lanNm // 비밀번호 확인을 입력하세요.
              : '',
          type: 'warning',
        })
      );
      return false;
    } else if (
      _type === 1 &&
      findPwInputs.userPw !== findPwInputs.userPwConfirm
    ) {
      dispatch(
        showSnackbar({
          message:
            lanList.length > 0
              ? lanList.filter((f) => f.lanId === 'ThePasswordIsDifferent')[0]
                  .lanNm
              : '',
          type: 'warning',
        })
      );
      return false;
    } else return true;
  };

  // 비밀번호 찾기(본인 확인) — 서버: GetFindPw Mode "0", 평문 UserId/UserName/Tel
  const SearchLogic3 = async () => {
    setLoading(true);

    if (!FindPwValidation(0)) {
      setLoading(false);
      return false;
    }

    try {
      const baseBody = {
        UserId: findPwInputs.userId.trim(),
        UserName: findPwInputs.userNm.trim(),
        Mode: '0',
        NewPassword: '',
      };
      const telVariants = BuildTelVariantsLogicN(findPwInputs.userTel);
      let data = null;

      for (const telVariant of telVariants) {
        try {
          const result = await Commons.Axios(
            'post',
            Global.base.useUrl + Global.urls.Account.getFindPw,
            { ...baseBody, Tel: telVariant },
            null,
            { suppressGlobalError: true }
          );
          data = result.data;
          if (IsOkTypeLogicN(data)) {
            setFindPwInputs({
              ...findPwInputs,
              userId: (
                data.userId ||
                data.UserId ||
                findPwInputs.userId
              ).trim(),
              successful: true,
            });
            return;
          }
        } catch (err) {
          if (ShouldContinueTelVariantAfterErrorLogicN(err)) continue;
          throw err;
        }
      }

      throw new Error(
        data?.message ||
          data?.Message ||
          lanList.find((f) => f.lanId === 'IdNotFound')?.lanNm ||
          '계정 정보를 확인할 수 없습니다.'
      );
    } catch (e) {
      if (e.shouldShowDialog) {
        return;
      }
      const msg =
        e?.response?.data?.message ||
        e?.response?.data ||
        e?.message ||
        '비밀번호 찾기 처리 중 오류가 발생했습니다.';
      dispatch(showSnackbar({ message: String(msg), type: 'warning' }));
      await handleError(e, {
        url: Global.base.useUrl + Global.urls.Account.getFindPw,
        method: 'post',
      });
    } finally {
      setLoading(false);
    }
  };

  // 비밀번호 재설정 — 서버: GetFindPw Mode "1"(검증 후 변경), NewPassword 평문
  const SaveLogic1 = async () => {
    setLoading(true);

    if (!FindPwValidation(1)) {
      setLoading(false);
      return false;
    }

    try {
      const baseBody = {
        UserId: findPwInputs.userId.trim(),
        UserName: findPwInputs.userNm.trim(),
        Mode: '1',
        NewPassword: findPwInputs.userPw.trim(),
      };
      const telVariants = BuildTelVariantsLogicN(findPwInputs.userTel);
      let data = null;

      for (const telVariant of telVariants) {
        try {
          const result = await Commons.Axios(
            'post',
            Global.base.useUrl + Global.urls.Account.getFindPw,
            { ...baseBody, Tel: telVariant },
            null,
            { suppressGlobalError: true }
          );
          data = result.data;
          if (IsOkTypeLogicN(data)) {
            setDialog({
              ...dialog,
              open: false,
            });
            setFindPwInputs({
              userId: '',
              userNm: '',
              userTel: '',
              userPw: '',
              userPwConfirm: '',
              successful: false,
            });

            dispatch(
              showSnackbar({
                message:
                  data?.message ||
                  data?.Message ||
                  lanList.find((f) => f.lanId === 'ItHasBeenChanged')?.lanNm ||
                  '변경되었습니다.',
                type: 'success',
              })
            );
            return;
          }
        } catch (err) {
          if (ShouldContinueTelVariantAfterErrorLogicN(err)) continue;
          throw err;
        }
      }

      throw new Error(
        data?.message || data?.Message || '비밀번호 변경에 실패했습니다.'
      );
    } catch (e) {
      if (e.shouldShowDialog) {
        return;
      }
      const msg =
        e?.response?.data?.message ||
        e?.response?.data ||
        e?.message ||
        '비밀번호 변경 중 오류가 발생했습니다.';
      dispatch(showSnackbar({ message: String(msg), type: 'error' }));
      await handleError(e, {
        url: Global.base.useUrl + Global.urls.Account.getFindPw,
        method: 'post',
      });
    } finally {
      setLoading(false);
    }
  };

  // 임시 비밀번호 발급 → FindPw 성공 화면에 표시
  const SaveLogic4 = async () => {
    setLoading(true);
    try {
      const phoneId = (findPwInputs.userTel || '').replace(/[^0-9]/g, '');
      const userId = findPwInputs.userId || phoneId;
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.saveTempPassword,
        {
          UserId: Commons.EncryptAES(userId),
        }
      );
      const data = result.data;

      if (data?.type === 'Ok') {
        let tempPassword = '';
        if (data.tempPassword) {
          try {
            tempPassword = Commons.DecryptoAES(data.tempPassword) || '';
          } catch (_) {
            tempPassword = '';
          }
        }

        setFindPwInputs((prev) => ({
          ...prev,
          userId: data.userId,
          userTel: data.userId,
          tempPassword,
          issueMessage: data.message || '임시 비밀번호가 발급되었습니다.',
          successful: true,
          identityErrMsg: '',
        }));
        return true;
      }

      dispatch(
        showSnackbar({
          message: data?.message || '임시 비밀번호 발급에 실패했습니다.',
          type: 'warning',
        })
      );
    } catch (e) {
      console.log('Error: ', e);
      dispatch(
        showSnackbar({
          message: e.message || '임시 비밀번호 발급에 실패했습니다.',
          type: 'error',
        })
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  // 아이디 중복 체크
  const CheckUserId = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.CheckUserId,
        {
          value1: Commons.EncryptAES(signUpInputs.userId),
        }
      ).then((result) => {
        let data = result.data;

        if (data.type === 'Error') {
          throw new Error(data.message);
        } else {
          if (data) {
            setSignUpInputs({
              ...signUpInputs,
              idDuplicationCheck: true,
            });
          } else {
            setSignUpInputs({
              ...signUpInputs,
              userId: '',
              idDuplicationCheck: false,
            });
          }
        }
      });
    } catch (e) {
      // 에러 처리 (401 등은 자동으로 다이얼로그 표시)
      if (e.shouldShowDialog) {
        return;
      }
      await handleError(e, {
        url: Global.base.useUrl + Global.urls.Account.CheckUserId,
        method: 'post',
      });
    } finally {
      setLoading(false);
    }
  };

  // 회원가입 시 정보 입력1 예외처리
  const SignUpIndex2Validation = () => {
    let passwordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!signUpInputs.userId) {
      dispatch(
        showSnackbar({ message: '아이디를 입력 하세요.', type: 'warning' })
      );
      return false;
    } else if (!signUpInputs.idDuplicationCheck) {
      dispatch(
        showSnackbar({ message: '아이디 중복체크를 하세요.', type: 'warning' })
      );
      return false;
    } else if (!signUpInputs.userNm) {
      dispatch(
        showSnackbar({ message: '이름을 입력 하세요.', type: 'warning' })
      );
      return false;
    } else if (!signUpInputs.userPw) {
      dispatch(
        showSnackbar({ message: '비밀번호를 입력 하세요.', type: 'warning' })
      );
      return false;
    } else if (!signUpInputs.userPwConfirm) {
      dispatch(
        showSnackbar({ message: '비밀번호를 확인 하세요.', type: 'warning' })
      );
      return false;
    } else if (signUpInputs.userPw !== signUpInputs.userPwConfirm) {
      dispatch(
        showSnackbar({ message: '비밀번호를 확인 하세요.', type: 'warning' })
      );
      return false;
    } else if (!passwordRegex.test(signUpInputs.userPw)) {
      dispatch(
        showSnackbar({ message: '비밀번호를 확인 하세요.', type: 'warning' })
      );
      return false;
    } else if (
      !emailRegex.test(signUpInputs.userEmail1 + '@' + signUpInputs.userEmail2)
    ) {
      dispatch(
        showSnackbar({ message: '아이디를 입력 하세요.', type: 'warning' })
      );
      return false;
    } else {
      return true;
    }
  };

  // 회원가입 시 정보 입력2 예외처리
  const SignUpIndex3Validation = () => {
    if (!signUpInputs.userEmTel) {
      dispatch(
        showSnackbar({ message: '비상연락처를 입력 하세요.', type: 'warning' })
      );

      return false;
    } else if (!signUpInputs.userBlood) {
      dispatch(
        showSnackbar({ message: '혈액형을 선택 하세요.', type: 'warning' })
      );

      return false;
    } else if (signUpInputs.userType === 1 && !signUpInputs.userAuth) {
      dispatch(
        showSnackbar({ message: '권한을 선택 하세요.', type: 'warning' })
      );

      return false;
    } else {
      return true;
    }
  };

  // 지역별 현장 목록 조회
  const SearchLogic4 = async (_resion) => {
    setLoading(true);
    let siteData = [];

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.SpLoginR4,
        { value1: Commons.EncryptAES(_resion) }
      ).then((result) => {
        let data = result.data;

        if (data.type === 'Error') {
          throw new Error(data.message);
        } else {
          if (data.length > 0) {
            data.forEach((item) => {
              siteData.push({
                value: item.siteCd,
                name: `${item.siteNm}(${item.address1 + item.address2})`,
              });
            });
          }
          setSiteList(siteData);
        }
      });
    } catch (e) {
      // 에러 처리 (401 등은 자동으로 다이얼로그 표시)
      if (e.shouldShowDialog) {
        return;
      }
      await handleError(e, {
        url: Global.base.useUrl + Global.urls.Account.SpLoginR4,
        method: 'post',
      });
    } finally {
      setLoading(false);
    }
  };

  // 사업체 목록 조회
  const SearchLogic5 = async () => {
    setLoading(true);
    let custData = [];

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.SpLoginR5
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          data.forEach((item) => {
            custData.push({
              value: item.custCd,
              name: `${item.custNm}(CEO: ${item.ceo}, 담당자: ${item.custId})`,
            });
          });
        }
        setCustList(custData);
      });
    } catch (e) {
      // 에러 처리 (401 등은 자동으로 다이얼로그 표시)
      if (e.shouldShowDialog) {
        return;
      }
      await handleError(e, {
        url: Global.base.useUrl + Global.urls.Account.SpLoginR5,
        method: 'post',
      });
    } finally {
      setLoading(false);
    }
  };

  // 회원가입 저장 함수
  const SaveLogic2 = async () => {
    setLoading(true);
    let authDtl = '';

    try {
      if (signUpInputs.userType === 'EMPLOYEE') {
        authDtl = signUpInputs.userType;
      } else if (signUpInputs.userAuth === 'SITE_MANAGER') {
        authDtl = siteList.filter((f) => f.name === siteManagerSite)[0].value;
      } else if (signUpInputs.userAuth === 'HEAD_MANAGER') {
        authDtl = custList.filter((f) => f.name === headManagerSite)[0].value;
      } else if (
        signUpInputs.userAuth === 'BUSINESS_OWNER' ||
        signUpInputs.userAuth === 'VIEWER' ||
        signUpInputs.userAuth === 'ADMIN'
      ) {
        authDtl = signUpInputs.authRegion;
      }
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Account.SpLoginU3,
        {
          value1: Commons.EncryptAES(signUpInputs.userId),
          value2: Commons.EncryptAES(signUpInputs.userNm),
          value3: Commons.EncryptAES(signUpInputs.userPw),
          value4: Commons.EncryptAES(signUpInputs.userTel),
          value5: Commons.EncryptAES(signUpInputs.userEmTel),
          value6: Commons.EncryptAES(signUpInputs.userBlood),
          value7: Commons.EncryptAES(signUpInputs.userAddress1),
          value8: Commons.EncryptAES(signUpInputs.userAddress2),
          value9: Commons.EncryptAES(signUpInputs.userPost),
          value10: Commons.EncryptAES(signUpInputs.userNation),
          value11: Commons.EncryptAES(signUpInputs.userVisa),
          value12: Commons.EncryptAES(
            signUpInputs.userEmail1 + '@' + signUpInputs.userEmail2
          ),
          value13: Commons.EncryptAES(signUpInputs.userAuth),
          value14: Commons.EncryptAES(authDtl),
        }
      ).then(async (result) => {
        let data = result.data;

        if (signUpInputs.userType === 'EMPLOYEE') {
        } else if (data.length > 0) {
          if (data[0].type === 'Ok') {
            await Commons.Axios(
              'post1',
              Global.base.useUrl + Global.urls.FCM.fcm,
              [
                {
                  id: Commons.EncryptAES(data[0].requistId),
                  title: Commons.EncryptAES(data[0].title),
                  body: Commons.EncryptAES(data[0].body),
                  fcmToken: Commons.EncryptAES(data[0].fcmToken),
                  gubun: Commons.EncryptAES('0'),
                },
              ]
            );
          }
        } else {
          throw new Error('담당자를 찾지 못 했습니다. 본사에 문의하세요.');
        }
      });
    } catch (e) {
      // 에러 처리 (401 등은 자동으로 다이얼로그 표시)
      if (e.shouldShowDialog) {
        return;
      }
      await handleError(e, {
        url: Global.base.useUrl + Global.urls.Account.SpLoginU3,
        method: 'post',
      });
    } finally {
      setLoading(false);
    }
  };

  // Dialog 닫는 함수
  const CloseDialog = () => {
    setDialog({
      ...dialog,
      open: false,
    });
    setFindIdInputs({
      userId: '',
      foundIds: [],
      userNm: '',
      userTel: '',
      successful: false,
    });
    setFindPwInputs(createInitial(Login_Schema.fields.findPwForm));
    setSignUpInputs({
      ...signUpInputs,
      serviceUsingCheck: false, // 서비스 이용동의
      personalInformationCheck: false, // 개인정보 수집 및 이용동의
      locationSerciveCheck: false, // 위치기반 서비스 이용동의
      aged14Check: false, // 만 14세 이상동의
      marketingCheck: false, // 마케팅 목적 개인정보 수집 및 이용동의
      allAgreeCheck: false, // 전체 동의
      userId: '',
      idDuplicationCheck: '', // ID 중복 확인
      userNm: '',
      userPw: '',
      userPwConfirm: '', // Password 확인
      userTel: '',
      userEmTel: '',
      userEmail1: '',
      userEmail2: '',
      emailCombo: 'jigjub',
      userBlood: '',
      userAddress1: '',
      userAddress2: '',
      userPost: '',
      userNation: '',
      userVisa: '',
      userAuth: 'EMPLOYEE',
      authRegion: '',
      userAuthDtl: '',
      successful: false,
      userType: 0, // 0: 근로자, 1: 관리자
    });
    setSiteList([]);
    setSiteManagerSite('');
    setSiteManagerSiteInput('');
  };

  return (
    <div className="Login">
      <Login
        inputs={inputs}
        setInputs={setInputs}
        lanCdList={lanCdList}
        lanList={lanList}
        dialog={dialog}
        setDialog={setDialog}
        ChangeCheckbox={ChangeCheckbox}
        DialogLogic={DialogLogic}
        LoginLogic={LoginLogic}
        SearchLogic1={SearchLogic1}
        confirmId={confirmId}
        confirmPw={confirmPw}
        successLogin={successLogin}
      />
      <Loading open={loading} />

      <FindPw
        open={dialog.open && dialog.type === 'FindPw'}
        onClose={CloseDialog}
        findPwInputs={findPwInputs}
        setFindPwInputs={setFindPwInputs}
        SaveLogic4={SaveLogic4}
        loading={loading}
      />

      <Dialog
        fullScreen={Commons.IsMobile() ? true : false}
        fullWidth
        open={dialog.open && dialog.type !== 'FindPw'}
        onClose={CloseDialog}
        PaperProps={
          dialog.type === 'FindId'
            ? {
                elevation: 8,
                sx: {
                  borderRadius: 2,
                  overflow: 'hidden',
                },
              }
            : undefined
        }
        dividers={dialog.type === 'FindId'}
        titleSx={
          dialog.type === 'FindId'
            ? {
                py: 2,
                px: { xs: 2, sm: 3 },
              }
            : undefined
        }
        contentSx={
          dialog.type === 'FindId'
            ? {
                pt: 3,
                pb: 2,
                px: { xs: 2, sm: 3 },
              }
            : undefined
        }
        actionsSx={
          dialog.type === 'FindId'
            ? {
                px: { xs: 2, sm: 3 },
                py: 2,
                borderTop: 1,
                borderColor: 'divider',
                bgcolor: 'grey.50',
              }
            : undefined
        }
        title={
          Commons.IsMobile() && dialog.type === 'SignUp' ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              {dialog.title}
              <IconButton onClick={CloseDialog}>
                <CloseIcon />
              </IconButton>
            </Box>
          ) : dialog.type === 'FindId' ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.25,
              }}
            >
              <PersonSearch sx={{ color: '#78CB70', fontSize: 28 }} />
              <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                {dialog.title}
              </Typography>
            </Box>
          ) : (
            dialog.title
          )
        }
        content={
          dialog.type === 'FindId' ? (
            <FindId
              lanList={lanList}
              findIdInputs={findIdInputs}
              setFindIdInputs={setFindIdInputs}
            />
          ) : (
            <SignUp
              lanList={lanList}
              codeList={codeList}
              signUpInputs={signUpInputs}
              setSignUpInputs={setSignUpInputs}
              authGroups={authGroups}
              regions={regions}
              siteManagerSite={siteManagerSite}
              setSiteManagerSite={setSiteManagerSite}
              siteManagerSiteInput={siteManagerSiteInput}
              setSiteManagerSiteInput={setSiteManagerSiteInput}
              siteList={siteList}
              headManagerSite={headManagerSite}
              setHeadManagerSite={setHeadManagerSite}
              headManagerSiteInput={headManagerSiteInput}
              setHeadManagerSiteInput={setHeadManagerSiteInput}
              custList={custList}
              CheckUserId={CheckUserId}
              SignUpIndex2Validation={SignUpIndex2Validation}
              SignUpIndex3Validation={SignUpIndex3Validation}
              SearchLogic4={SearchLogic4}
              SearchLogic5={SearchLogic5}
              SaveLogic2={SaveLogic2}
              CloseDialog={CloseDialog}
            />
          )
        }
        actions={CreateDialogButton(dialog.type)}
        closeButtonName={
          lanList.length > 0
            ? lanList.filter((f) => f.lanId === 'Close')[0].lanNm
            : ''
        }
        useCloseButton={dialog.type === 'SignUp' ? false : true}
      />
    </div>
  );
}
// 내 인생이 와 글노...
export default LoginFunction;
